import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';

import SingleAdvice from './SingleAdvice/SingleAdvice';

import css from './FinancialAdvice.module.scss';

import data from './data.json';

const FinancialAdvice = () => {
	const images = useStaticQuery(IMAGES_QUERY);
	return (
		<section className={css.financialAdvice}>
			<BackgroundImage
				Tag="div"
				className={css.container}
				fluid={images.background.childImageSharp.fluid}
			></BackgroundImage>
			<div className={css.contentWrapper}>
				<h2 data-aos="fade-up">Data-driven AI Advisory</h2>
				<h4 data-aos="fade-up">
					We combine our veteran advisors' industry expertise with data
				</h4>
				<div className={css.cards}>
					{data.map(({ id, src, alt, heading, description }) => (
						<SingleAdvice
							key={id}
							src={src}
							alt={alt}
							heading={heading}
							description={description}
						/>
					))}
				</div>
				<div className={css.cta} data-aos="fade-up">
					<Link to="/financial-planning">
						<button className="btn btnGreen">
							Get financial advice for your goals
						</button>
					</Link>
					<Link to="/moneybot" className={`${css.askMoneybot} linkUnderline`}>
						<span>Ask MoneyBot!</span> Get predictions on the best mutual funds
					</Link>
				</div>
			</div>
		</section>
	);
};

const IMAGES_QUERY = graphql`
	{
		background: file(relativePath: { eq: "home/financial-advise.png" }) {
			childImageSharp {
				fluid {
					...GatsbyImageSharpFluid_withWebp_noBase64
				}
			}
		}
	}
`;

export default FinancialAdvice;
